<template>
	<div class="row">
		<div class="col-3">
			<router-link :to="'/dataset/' + record_id">
				<button type="button" class="btn btn-primary btn-lg btn-block">{{ $t('Structure') }}</button>
			</router-link>
		</div>
		<!-- /.col -->

		<div v-show="record_id > 0" class="col-3">
			<router-link :to="'/dataset/' + record_id + '/data'">
				<button type="button" class="btn btn-primary btn-lg btn-block">{{ $t('Data') }}</button>
			</router-link>
		</div>
	</div>
</template>

<script>
// Define a new component called button-counter
export default {
	props: {
		record_id: {
			default: 0,
		},
	},
}
</script>
